<template>
  <div class="UserProfile">
    <div class="user-detail-card">
      <div
        class="top-line"
        :style="[
          userProfile.mark_as_verified_user &&
          !userProfile.is_active_ra &&
          !isAdmin
            ? { backgroundColor: '#e72726' }
            : userProfile.is_active_ra || isAdmin
            ? { backgroundColor: '#bea66e' }
            : {},
        ]"
      ></div>
      <div
        class="profile-section text-center"
        v-if="userProfile"
        @click="goToExpertStore()"
      >
        <div class="relative profile-pic-outer">
          <img
            src="../assets/images/RA-dashboard/Non-Active Circle.svg"
            alt=""
            class="user-state-border"
            v-if="
              userProfile.mark_as_verified_user &&
                !userProfile.is_active_ra &&
                !isAdmin
            "
          />
          <img
            src="../assets/images/RA-dashboard/Active RA (Golden Circle).svg"
            alt=""
            class="user-state-border"
            v-else-if="userProfile.is_active_ra || isAdmin"
          />
          <div style="background-color: #ffff;">
            <img
              :src="serverHostName + userProfile.picture"
              v-if="userProfile.picture"
              class="profile-pic"
            />
            <img
              src="../assets/images/navBar/avatar.jpg"
              v-else
              class="profile-pic"
            />
          </div>
        </div>

        <div class="profile-details-section">
          <div
            class="font-08rem font-weight-600 top-margin-10 capitalize"
            v-if="userProfile.full_name"
          >
            {{ !isAdmin ? userProfile.full_name : isAdmin ? "StockAnts" : "" }}
            <el-tooltip
              v-if="userProfile.mark_as_verified_user"
              class="item"
              effect="dark"
              content="Verified SEBI registered Expert"
              placement="top"
            >
              <img
                class="info-Logo cursor-pointer"
                src="../assets/images/verify.svg"
                style="width: 16px; position: relative; top: 3px;"
                alt
              />
            </el-tooltip>
          </div>
          <div
            class="font-08rem font-weight-600 top-margin-10 ellipsis"
            v-else-if="!userProfile.full_name && userProfile.email"
          >
            {{ !isAdmin ? userProfile.email : isAdmin ? "StockAnts" : "" }}
          </div>

          <div class="input-label-gray top-margin-5">
            {{ !isAdmin ? userProfile.profession : isAdmin ? "Company" : "" }}
          </div>

          <div
            class="flex-center top-margin-15 sebi-number-block"
            v-if="
              userProfile.sebi_regi_number &&
                userProfile.sebi_regi_number.length
            "
          >
            <div
              class="text sebi"
              :style="[
                userProfile.mark_as_verified_user && !userProfile.is_active_ra
                  ? { backgroundColor: '#e72726' }
                  : userProfile.is_active_ra || isAdmin
                  ? { backgroundColor: '#bea66e' }
                  : {},
              ]"
            >
              SEBI <i class="el-icon-check"></i>
            </div>
            <div class="text number">{{ userProfile.sebi_regi_number }}</div>
          </div>
        </div>
      </div>
      <div
        v-if="userProfile && userProfile.profession != 'Retail Investor'"
        class="bottom-line"
        :style="[
          userProfile.mark_as_verified_user &&
          !userProfile.is_active_ra &&
          !isAdmin
            ? { backgroundColor: '#ffe3e3' }
            : userProfile.is_active_ra || isAdmin
            ? { backgroundColor: '#fff6e2' }
            : {},
        ]"
      >
        <div>
          <span
            class="input-label-bold-gray"
            :style="[
              userProfile.mark_as_verified_user &&
              !userProfile.is_active_ra &&
              !isAdmin
                ? { color: '#e72726' }
                : userProfile.is_active_ra || isAdmin
                ? { color: '#c6a555' }
                : {},
            ]"
          >
            Last
            {{ isAdmin ? "Reco" : "Published" }}
            :
          </span>

          <span v-if="isAdmin">
            {{
              userProfile.stockants_last_reco &&
              userProfile.stockants_last_reco.length &&
              userProfile.stockants_last_reco != "---"
                ? moment(userProfile.stockants_last_reco).format(
                    "DD MMM YY h:MMA"
                  ) + " IST"
                : "---"
            }}
          </span>
          <span v-if="!isAdmin">
            {{
              userProfile.user_last_reco &&
              userProfile.user_last_reco.length &&
              userProfile.user_last_reco != "---"
                ? moment(userProfile.user_last_reco).format("DD MMM YY h:MMA") +
                  " IST"
                : "---"
            }}
          </span>
          <!-- {{
            isAdmin
              
              : userProfile.user_last_reco
              ? moment(userProfile.user_last_reco).format("DD MMM YY h:MMA") +
                " IST"
              : "---"
          }} -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from "../networkConfig";
import Hexagon from "@/components/Hexagon.vue";
import { EventBus } from "../eventBus";
import moment from "moment";
export default {
  name: "UserProfile",

  components: {
    Hexagon,
  },
  props: ["active_period"],

  data() {
    return {
      serverHostName: serverHostName,
      moment: moment,
      isAdmin: false,
    };
  },

  beforeCreate() {
    if (localStorage.getItem("profile")) {
      setTimeout(() => {
        var websiteUserType = localStorage.getItem("websiteUserType")
          ? JSON.parse(localStorage.getItem("websiteUserType"))
          : {};
        var userProfile = JSON.parse(localStorage.getItem("profile"));

        var internalTeamList = [
          "krishaa0801@gmail.com",
          "joshiakshay719@gmail.com",
          "fegde.mayur@gmail.com",
          "snehalvpatil25@gmail.com",
          "sumittarkas0001@gmail.com",
          "bid.pallavi@gmail.com",
          "pallavi.bid@stockants.com",
          "bhushanm705811@gmail.com",
          "admin@stockants.com",
          "sumittarkas001@gmail.com",
          "satavchetan08@gmail.com",
          "amanm3047@gmail.com",
        ];

        userProfile.email = userProfile.email.toLowerCase();

        if (
          websiteUserType &&
          websiteUserType.userType == "stockAnts" &&
          internalTeamList.includes(userProfile.email)
        ) {
          this.isAdmin = true;
        }
      }, 0);
    }
  },

  mounted() {
    EventBus.$on("profilePic", (data) => {
      this.userProfile.picture = data;
    });
  },

  watch: {},

  methods: {
    goToExpertStore() {
      if (this.userProfile.profession != "Retail Investor") {
        this.$router.push({
          path: "/expert-store",
          query: {
            user_id: this.userProfile.id,
            user: "individual",
            name: this.userProfile.full_name,
          },
        });
      }
    },
  },
  beforeDestroy() {
    EventBus.$off();
  },
  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    // show profile card for retail investor if has_recommendation is tru
    checkEligiblity() {
      // this.userProfile.has_recommendation = true;
      if (this.userProfile.has_recommendation == undefined) {
        this.userProfile.has_recommendation = false;
      }
      if (
        this.userProfile &&
        this.userProfile.profession == "Retail Investor" &&
        this.userProfile.has_recommendation == false
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.UserProfile {
  .input-label-bold-gray {
    font-weight: 600;
  }
  .faded-border-bottom {
    display: block;
    border: none;
    color: #fff;
    height: 1px;
    background: -webkit-gradient(
      radial,
      50% 50%,
      0,
      50% 50%,
      450,
      from(#d3d0d0),
      to(#fff)
    );

    width: 70%;
    margin: 10px auto 25px;
  }

  .bottom-line {
    width: 100%;
    background-color: #f3f3f3;
    font-size: 10px;
    color: #000;
    font-weight: 600;
    margin: 0 auto;
    text-align: center;
    padding: 15px 0;
    border-radius: 0 0 10px 10px;
    .input-label-bold-gray {
      font-size: 10px;
    }
  }

  .user-detail-card {
    background-color: #ffff;
    margin: 70px 20px 30px;
    border-radius: 9px;
    cursor: pointer;
    box-shadow: 0px 3px 11px 2px #dcd6d6;
  }
  .profile-section {
    position: relative;
    z-index: 2;
  }
  .top-line {
    height: 20px;
    width: 100%;
    // background-color: #e72726;
    border-radius: 9px;
    position: relative;
    z-index: -1;
    top: -6px;
  }

  .profile-details-section {
    padding: 15px;
    padding-top: 50px;
  }
  .sebi-number-block {
    .text {
      padding: 7px 10px;
      font-size: 0.7rem;
      font-weight: 600;
    }
    i {
      font-weight: 800;
      font-size: 0.8rem;
    }
    .sebi {
      color: #ffff;
      border-radius: 8px 0 0 8px;
    }
    .number {
      border-radius: 0 8px 8px 0;
      background-color: #f2f2f2;
    }
  }

  .profile-pic-outer {
    width: 215px;
    display: flex;
    justify-content: center;
  }
  .profile-pic {
    height: 115px;
    width: 115px;
    -o-object-fit: cover;
    object-fit: cover;
    border-radius: 100%;
    position: absolute;
    bottom: -45px;
    z-index: -1;
    left: 24%;
    background-color: #ffff;
  }

  .user-state-border {
    position: absolute;
    bottom: -56px;
    width: 140px;
  }

  .rank-wrapper {
    position: absolute;
    bottom: -8px;
    right: 0;
    left: 0;
  }
  .more-details-section {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
  }
}
</style>
